"use client";
import { jsxs as n, jsx as l } from "react/jsx-runtime";
const s = ({
  title: i,
  titleId: d,
  desc: e,
  descId: h,
  ...a
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sn",
    viewBox: "0 0 640 480",
    "aria-labelledby": d,
    "aria-describedby": h,
    ...a,
    children: [
      e ? /* @__PURE__ */ l("desc", { id: h, children: e }) : null,
      i ? /* @__PURE__ */ l("title", { id: d, children: i }) : null,
      /* @__PURE__ */ n("g", { fillRule: "evenodd", strokeWidth: "1pt", children: [
        /* @__PURE__ */ l("path", { fill: "#0b7226", d: "M0 0h213.3v480H0z" }),
        /* @__PURE__ */ l("path", { fill: "#ff0", d: "M213.3 0h213.3v480H213.3z" }),
        /* @__PURE__ */ l("path", { fill: "#bc0000", d: "M426.6 0H640v480H426.6z" })
      ] }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#0b7226",
          d: "M342 218.8h71.8l-56.6 43.6 20.7 69.3-56.6-43.6-56.6 41.6 20.7-67.3-56.6-43.6h69.8l22.7-71.3z"
        }
      )
    ]
  }
);
export {
  s as default
};
